<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ cockfight_title }}
      td
        PTSelect(
          ref="cockfight_upline_pt"
          :dirty="$v.cockfight_upline_pt.$dirty"
          :error="$v.cockfight_upline_pt.$error"
          :options="cockfight_upline_options"
          :value="cockfight_upline_pt"
          @input="input_cockfight_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="cockfight_account_pt"
          :dirty="$v.cockfight_account_pt.$dirty"
          :error="$v.cockfight_account_pt.$error"
          :options="cockfight_account_options"
          :value="cockfight_account_pt"
          @input="input_cockfight_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="cockfight_upline_remaining"
          :dirty="$v.cockfight_upline_remaining.$dirty"
          :error="$v.cockfight_upline_remaining.$error"
          :options="cockfight_account_options"
          :value="cockfight_upline_remaining"
          @input="$v.cockfight_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="cockfight_account_min"
          :dirty="$v.cockfight_account_min.$dirty"
          :error="$v.cockfight_account_min.$error"
          :options="cockfight_min_options"
          :value="cockfight_account_min"
          @input="$v.cockfight_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: ""
  },
  data() {
    return {
      cockfight_upline_pt: 0,
      cockfight_account_pt: 0,
      cockfight_upline_remaining: 0,
      cockfight_account_min: 0
    }
  },
  validations() {
      return {
      cockfight_upline_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('CF')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              total = value
            } else {
              total = value + this.cockfight_account_pt
            }
            if(total < this.cockfight_upline_min) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      },
      cockfight_account_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('CF')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              return true
            } else {
              total = value + this.cockfight_upline_pt
              if(total < this.cockfight_upline_min) {
                return false
              } else {
                return true
              }
            }
          } else {
            return true
          }
        }
      },
      cockfight_upline_remaining: {
        required
      },
      cockfight_account_min: {
        required
      }
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    cockfight_title: function () {
      return this.$t("ui.esports2") + " (" + this.cockfight_upline_min + "%-" + this.cockfight_upline_max + "%)"
    },
    cockfight_upline_min: function() {
      return this.$store.getters.getPTCF[0].account_min
    },
    cockfight_upline_max: function() {
      return this.$store.getters.getPTCF[0].account_pt
    },
    cockfight_account_max: function() {
      return this.cockfight_upline_max - this.cockfight_upline_pt
    },
    cockfight_upline_options: function() {
      return this.$helpers.getPTRateList(this.cockfight_upline_max)
    },
    cockfight_account_options: function() {
      return this.$helpers.getPTRateList(this.cockfight_account_max)
    },
    cockfight_min_options: function() {
      return this.$helpers.getPTRateList(this.cockfight_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.cockfight_upline_pt.$model = this.cockfight_upline_max
    }
    if(!this.$helpers.isPlatformEnabled('CF')) {
      this.$v.cockfight_upline_pt.$model = this.cockfight_upline_min
    }
  },
  methods: {
    input_cockfight_upline_pt(e) {
      this.$v.cockfight_upline_pt.$model = e
      this.$v.cockfight_account_pt.$model = this.cockfight_account_max

      if (this.cockfight_upline_remaining > this.cockfight_account_max) {
        this.$v.cockfight_upline_remaining.$model = 0
      }
      if (this.cockfight_account_min > this.cockfight_account_pt) {
        this.$v.cockfight_account_min.$model = 0
      }
    },
    input_cockfight_account_pt(e) {
      this.$v.cockfight_account_pt.$model = e
      if (this.cockfight_account_min > this.cockfight_account_pt) {
        this.$v.cockfight_account_min.$model = 0
      }
    }
  }
}

</script>